export default __webpack_public_path__ + "static/media/phcnKano.c9caaa5b.svg";